import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import { FaCheck } from "@react-icons/all-files/fa/FaCheck"

import { SectionContext } from "../context/sectionContext"
import { PageContext } from "../context/pageContext"
import { JourneyContext } from "../context/journeyContext"
import {
  generateBI,
  fetchAllJourneyData,
  pdfDownload,
  uploadDocument,
  saveApplication,
  fetchApplicationDetails
} from "../../services/apiservice"
import {
  getDateInFormat,
  getStateFromCode,
  getAge,
  findCurrentJourneyCode,
  getValueFromLookup,
} from "../services/helperFunctions"

const RadioContainer = styled.div`
  width: 100%;
  display: block;
  flex-direction: column;
  margin: 15px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;

  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background-color: #fff;
    padding: 2px 5px;
    z-index: 999;
    position: relative;
    display: inline-block;
    cursor: default;
    max-width: 100%;
    & > .radio-label {
      text-align: center;
    }
  }

  .card {
    border-radius: 1rem;
    padding: 2rem 0;
    border-radius: 15px;
    background-color: #fff;
    position: relative;
    margin: 0px;
    margin-bottom: 0px;
    cursor: pointer;
    height: 13rem;
    margin-top: 0px;
    box-shadow: 0px 0px 20px #ccc;
    transition: all 200ms;

    .amount {
      color: black;
      margin-bottom: 2rem;
      margin-left: 7rem;
      border-left: 1px solid #ccc;
      padding-left: 2rem;
      height: 3rem;
    }
    .desc {
      padding: 0.8rem;
      background: #ededed;
      color: black;
      text-align: center;
    }
  }

  /*Check tick start  */
  .checked {
    background: #ededed;
    color: #ededed;
    position: absolute;
    left: 2rem;
    top: 2rem;
    height: 3rem;
    width: 3rem;
    border-radius: 50%;
    padding: 8px;
    & > * {
      font-size: 1.2rem;
    }
  }

  input:checked ~ .card .checked {
    background: #fff;
    color: ${props => props.channel === "A" ? "#3e505d" : props.channel === "B" ? "#a20a3a" : props.channel === "C" ? "#0ab0ef" : "#eb7f25"};
    color: var(--lumiq-card-bg);
  }
  /*Check tick end */

  .icon-container {
    font-size: 3rem;
    padding: 1rem;
    span {
      border-radius: 50%;
      padding: 1rem;

      background: #3e505d;
      .hero-icon {
        padding-top: 8px;
        color: #fff;
      }
    }
  }

  input:checked ~ .card {
    background-color: ${props => props.channel === "A" ? "#3e505d" : props.channel === "B" ? "#a20a3a" : props.channel === "C" ? "#0ab0ef" : "#eb7f25"};
    background-color: var(--lumiq-card-bg);
    color: #fff;
    .icon-container-1 {
      span {
        background: #fff;
        .hero-icon {
          color: #3e505d;
        }
      }
    }

    .amount {
      color: white;
      margin-bottom: 2rem;
      margin-left: 7rem;
      border-left: 1px solid #ccc;
      padding-left: 2rem;
      height: 3rem;
    }
    .desc {
      padding: 0.8rem;
      background: #fff;
      color: black;
      text-align: center;
    }
  }

  input:not(:checked) ~ .card {
    opacity: 0.5;
  }
`

export default function BenefitIllustrationPos(props) {
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [pageState, setPageState] = useContext(PageContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)

  const [allJourneyData, setAllJourneyData] = useState()
  const [biApiData, setBiApiData] = useState()
  const [payNowOrLater, setPayNowOrLater] = useState("now")
  const [pdfData, setPdfData] = useState("")
  const [agreeToDeclaration, setAgreeToDeclaration] = useState(false)

  const handlePayOption = ({ target }) => {
    console.log(target.value, "value in BI")
    if (target.value === "now") {
      setPayNowOrLater("now")
    } else if (target.value === "later") {
      setPayNowOrLater("later")
    }
  }

  const handleAgreeChange = () => {
    setAgreeToDeclaration(prev => !prev)
  }

  const handlePrevious = () => {
    props.setCurrentSectionIndex(prev => prev - 1) // this moves to previous section on same page

    setJourneyState(prev => {
      return {
        ...prev,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex,
        lastPageCode: props.pageId,
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        journeyCode: findCurrentJourneyCode(
          props.pageId,
          props.sections[props.currentSectionIndex].sectionId
        ),
      }
    })
  }

  const handleProceed = async ev => {
    ev.preventDefault()
    await downloadPdf()
    const b64Data = pdfData;
    const blob = b64toBlob(b64Data, "image/png");
    let formData = new FormData()
    if (blob) {
      const file = blob
      formData.set("doc", file)
      formData.set("sub", false)
      formData.set("docPurpose", "BIPDF")
      try {
        const res = await uploadDocument(formData, journeyState.applicationNo)
        console.log({ res })
      } catch (error) {
        console.log(error)
      }
    }
    function b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || ""
      sliceSize = sliceSize || 512

      var byteCharacters = atob(b64Data)
      var byteArrays = []

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize)

        var byteNumbers = new Array(slice.length)
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        var byteArray = new Uint8Array(byteNumbers)

        byteArrays.push(byteArray)
      }

      var blob = new Blob(byteArrays, { type: contentType })
      return blob
    }

    if (payNowOrLater === "now") {
      let temp = journeyState.journeySteps.pages
      let element = temp[3]
      temp.splice(3, 1)
      temp.splice(2, 0, element)

      setJourneyState(prev => {
        return {
          ...prev,
          journeySteps: {
            pages: temp,
          },
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex,
          lastPageCode: props.pageId,
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
          paymentStep:"N",
          journeyCode: findCurrentJourneyCode(
            props.pageId,
            props.sections[props.currentSectionIndex].sectionId
          ),
        }
      })
    }
    let sendPayload = {
      applicationData:  journeyState.journeyData,
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        premium: JSON.parse(biApiData?.BIJson)?.[0].TOTAL_5 ,
        lastPageCode: props.pageId,
        planOption: journeyState.planOption,
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
      },
    }
    saveApplication(sendPayload).then(res => {
      console.log(res, "application response")
      props.setCurrentSectionIndex(0) // this moves to first section of next page
      props.setCurrentPageIndex(prev => prev + 1) 
    }).catch(err => {
      console.log(err, "err in saveApplication benefitIllustrationPOS")
    })
  }

  const handleReCalculate = () => {
    props.setCurrentPageIndex(0)
    props.setCurrentSectionIndex(0)

    const tempPage = journeyState.journeyData[0]

    setPageState(prev => {
      return {
        ...prev,
        pageId: tempPage.pageId,
        pageData: tempPage.pageData,
      }
    })

    const tempState = journeyState.journeyData[0].pageData[0]
    setSectionState(prev => {
      return {
        ...prev,
        sectionId: tempState.sectionId,
        sectionData: tempState.sectionData,
      }
    })
  }

  //async function to make API call
  const getData = async () => {
    let applicationDetailsPayload = {
      _id: journeyState.journeyId,
    }
    let applicationResult = await fetchApplicationDetails(applicationDetailsPayload)

    let payload = {
      journeyId: journeyState.journeyId,
    }
    let journeyResult = await fetchAllJourneyData(payload)
    generateBI(payload).then((data)=>{
      console.log(journeyResult, data, "vjhdvhhs")
      setAllJourneyData(journeyResult)
      setJourneyState(prev=>{return({
        ...prev,
        premium:JSON.parse(data?.data?.BIJson)?.[0].TOTAL_5,
        journeyData: applicationResult.applicationData
      })
    })
      setBiApiData(data.data)
    })
    .catch(err => {
      console.log("error in save application of save application and call BI function")
    })
    
  }

  useEffect(async () => {
    await getData()
  }, [])

  const downloadPdf = async () => {
    if (pdfData) {
      downloadLinkOfPdf(pdfData)
    } else {
      let pdfResult = await pdfDownload({
        applicationNumber: journeyState.applicationNo,
      })
      setPdfData(pdfResult.data.Base64Pdf)
      downloadLinkOfPdf(pdfResult.data.Base64Pdf)
    }

    function downloadLinkOfPdf(Base64Pdf) {
      const downloadLink = document.createElement("a")
      downloadLink.href = `data:application/pdf;base64,${Base64Pdf}`
      const fileName = "_ILN_BI.pdf"
      downloadLink.download = fileName
      downloadLink.click()
    }
  }
  const printPdf = async () => {
    if (pdfData) {
      PrintLinkOfPdf(pdfData)
    } else {
      let pdfResult = await pdfDownload({
        applicationNumber: journeyState.applicationNo,
      })
      setPdfData(pdfResult.data.Base64Pdf)
      PrintLinkOfPdf(pdfResult.data.Base64Pdf)
    }

    function PrintLinkOfPdf(Base64Pdf) {
      var winparams =
        "dependent=yes,locationbar=no,scrollbars=yes,menubar=yes," +
        "resizable,screenX=50,screenY=50,width=850,height=1050"

      var htmlPop =
        "<embed width=100% height=100%" +
        ' type="application/pdf"' +
        ' src="data:application/pdf;base64,' +
        escape(Base64Pdf) +
        '"></embed>'

      var printWindow = window.open("", "PDF", winparams)
      printWindow.document.write(htmlPop)
      printWindow.print()
    }
  }

  return (
    <>
      {/* checkbox css */}
      <style>
        {`/* The container */
      .checkbox-label {
        position: relative;
        padding-left: 35px;
        margin-bottom: 12px;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }

      /* Hide the browser's default checkbox */
      .checkbox-label input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
      }

      /* Create a custom checkbox */
      .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 25px;
        width: 25px;
        background-color: #CCC;
        border-radius:0;
      }

      /* On mouse-over, add a grey background color */
      .checkbox-label:hover input ~ .checkmark {
        background-color: #ccc;
      }

      /* When the checkbox is defaultChecked, add a theme background */
      .checkbox-label input:checked ~ .checkmark {
        background-color:  ${journeyState.channel === "A" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"};
        background-color:  var(--lumiq-tertiary);
      };
      }

      /* Create the checkmark/indicator (hidden when not defaultChecked) */
      .checkmark:after {
        content: "";
        position: absolute;
        display: none;
      }

      /* Show the checkmark when defaultChecked */
      .checkbox-label input:checked ~ .checkmark:after {
        display: block;
      }

      /* Style the checkmark/indicator */
      .checkbox-label .checkmark:after {
        left: 9px;
        top: 5px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
      }`}
      </style>
      <style>
        {`
        .details-card{      
            border-radius:10px;
            overflow:hidden;
            margin-bottom:1rem;     
            border:1px solid  ${journeyState.channel === "A" ? "#000000" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#0ab0ef" : "#eb7f25"};
            border:1px solid var(--lumiq-secondary);
        }
        
        .details-card::last-child{
            margin-bottom:0;       
        }
        
        .header{
            background: ${journeyState.channel === "A" ? "#404040" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"};
            background: var(--lumiq-secondary2);
            color: #fff;
            padding:1rem;
            text-align:center;
        }

        .data{
            display:flex;
            justify-content:space-between;
            padding:1rem;
            color:#797979;

        }
 

        .data:nth-child(odd){
            background:#f3f3f3;
        }

        .data:nth-child(even){}

        .static-content h3{
          font-size:22px
        }

        @media screen and (max-width: 800px){
          .static-content h3{
            font-size: 18px;
          }
            
        }

        .disclosure > *{
            margin-bottom:1rem;

        }      
        .btn-actions{
            display:flex;
            justify-content:center;
            gap:2rem;
            flex-wrap:wrap;
        }

        .btn-actions > * {
          min-width:13rem;
          text-align:center;
        }


        .form-check{
          font-size:1.8rem;
      }

      .form-check-input{
          height:2.5rem;
          width:2.5rem
      }

        @media screen and (max-width:767px){
          .previous-btn{
            padding:0
          }
          
        }

        `}
      </style>
      <style>
        {`
          .input-group.date .input-group-addon{
            background:none;
          }
    
          @media (max-width: 767px){

            .form-group {
              margin-bottom: 34px;
            }
            
          }
          .threetabs ul li:nth-child(2).active, .threetabs ul li:nth-child(3).active, .threetabs ul li:nth-child(4).active{
            margin-left:-2px;
          }
          ::-ms-clear {
            display: none;
          }    
          .d-none{
            display: none;
          }   
          .br-0{
            border-radius: 0px !important;
          }
              `}
      </style>

        <div className="landing-page1-design">
        <div className="container">
            {allJourneyData && biApiData && (
            <form id="personalDetail" name="personalDetail" action="" autoComplete="off">
                <div className="col-md-12 pl-pr mt-30-bi">
                <div className="iselect-box-design space-cover">
                    <div className="iselect-heading-design iselect-heading-wd ">
                    <h1 className="iselect-heading">Benefit Illustration </h1>
                    <span className="subhead">Canara HSBC Life Insurance Company Limited POS - Easy Bachat Plan &nbsp; | &nbsp; UIN: 136N068V01</span> </div>
                    <div className="app-quatation hidden-desktop-screen">
                    <div className="application-design-number">Application Number: 7000040463</div>
                    </div>
                    <div className="iselect-padding">
                    <div className="bi-summary">
                        <div className="auther-description mt-20">
                        <h3>Dear <strong>Rahul,</strong></h3>
                        <p className="benefit-title">Thank you for showing interest in our Canara HSBC Life Insurance Company Limited POS - Easy Bachat Plan. Based on the details provided by you, and reproduced below, the illustration customised to your requirements is appended.</p>
                        <p className="benefit-title">Please note that this illustration is indicative and the actual values may vary depending on performance of the non-participating fund managed by the Company.</p>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
                <div className="iselect-padding">
                
                
                
                <div className="Bi-design-structure-table mt-50 iselect-mg-bottom">
                    <div className="col-md-12 pl pr pl-pr">
                    <div className="table-responsive table-design">
                        <h2 className="headline-table">Personal Details of Life to be Assured</h2>
                        <div className="table-bg">
                        <table className="table">
                            <tbody>
                            <tr className="table-color-grey">
                                <td width="23%">Date of Birth</td>
                                <td width="27%" align="right" className="rd-tatav"> 02/03/1992</td>
                                <td width="27%" align="left"> Age</td>
                                <td width="23%" align="right"> 27 </td>
                            </tr>
                            <tr className="table-color">
                                <td>Gender</td>
                                <td align="right" className="rd-tatav"> Male </td>
                                <td align="left"> Designation</td>
                                <td align="right"> Director </td>
                            </tr>
                            <tr className="table-color-grey">
                                <td>Sum Assured </td>
                                <td align="right" className="rd-tatav"> 5,00,000</td>
                                <td align="left"> Date of Illustration		</td>
                                <td align="right"> 02/03/1992</td>
                            </tr>
                            
                                <tr className="table-color">
                                <td>Illustration for Standard Life	</td>
                                <td align="right" className="rd-tatav"> NA </td>
                                <td align="left" colSpan="2"> </td>
                                
                            </tr>
                            
                            </tbody>
                        </table>
                        </div>
                    </div>
                    </div>
                    <div className="col-md-12 pl pr pl-pr">
                    <div className="table-responsive table-design">
                        <h2 className="headline-table">Plan Details</h2>
                        <div className="table-bg">
                        <table className="table">
                            <tbody>
                            <tr className="table-color-grey">
                                <td width="26%"> Proposal Number	</td>
                                <td width="24%" align="right" className="rd-tatav">8525626922 </td>
                                <td width="26%" align="left"> Name of the Plan	</td>
                                <td width="24%" align="right"> 	Canara HSBC Life Insurance Company Limited POS - Easy Bachat Plan</td>
                            </tr>
                            <tr className="table-color">
                                <td>Plan Option	</td>
                                <td align="right" className="rd-tatav">Director</td>
                                <td align="left">Policy Term		</td>
                                <td align="right"> 10 </td>
                            </tr>
                            <tr className="table-color-grey">
                                <td>Premium Payment Term		 </td>
                                <td align="right" className="rd-tatav"> 5</td>
                                <td align="left">Premium Payment Frequency		</td>
                                <td align="right">Monthly</td>
                            </tr>
                            
                            
                                <tr className="table-color">
                                <td>Annualised Premium		</td>
                                <td align="right" className="rd-tatav"> 10000000.00</td>
                                <td align="left">Installment Premium Year 1 (without Goods and Services Tax & Cess (es)/ levy, if any)	</td>
                                <td align="right">8534</td>
                            </tr>
                            <tr className="table-color-grey">
                                <td>Installment Premium Year 2 onwards (without Goods and Services Tax & Cess (es)/ levy, if any):		 </td>
                                <td align="right" className="rd-tatav"> 5286</td>
                                <td align="left">Installment Premium for Year 1 (with Goods and Services Tax & Cess (es)/ levy, if any):		</td>
                                <td align="right"> 5286</td>
                            </tr>
                            
                                <tr className="table-color">
                                <td>Installment Premium from Year 2 onwards (with Goods and Services Tax & Cess (es) levy, if any):		</td>
                                <td align="right" className="rd-tatav"> 5286</td>
                                <td align="left" colSpan="2"></td>
                            
                            </tr>
                            
                            </tbody>
                        </table>
                        </div>
                    </div>
                    </div>
                    
                </div>
                
                
                
                <div className="iselect-mg-bottom mt-20">
                <div className="col-md-12 pl-pr">
                    <div className="total-mt-design"> <span>Total Maturity Value (8%) - 715000</span> <span> |</span> <span> Total Maturity Value (4%) - 560000</span> </div>
                </div>
                </div>
                <div className="clearfix"></div>
                <div className="col-md-12">
                <div className="transactionDetailsWrap">
                    <div className="detailContentWrap">
                    <div className="row">
                        <div className="buttonWrap">
                        <div className="button submit-btn"><a aria-hidden="true" onClick={handleReCalculate}>RE-CALCULATE</a></div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
                
                <div className="clearfix"></div>
                <div className="row iAgree text-center">
                    <div className="form-group">
                    <div className="inner-addon left-addon">
                        <div className="checkbox1">
                        <input name="checkboxG6" id="checkboxG6" className="css-checkbox" type="checkbox" onClick={handleAgreeChange} />
                        <label htmlFor="checkboxG6" className="css-label"> I agree to the Disclosures and Disclaimers as mentioned below </label>
                        </div>
                    </div>
                    </div>
                </div>
                <div className="clearfix"></div>
                <div className="iselect-padding">
                    <div className="col-md-6 col-xs-12 ">
                      <RadioContainer channel={journeyState.channel}>
                        <div>
                          <label className="width">
                            <input
                              type="radio"
                              name="pay"
                              value="now"
                              hidden
                              onChange={handlePayOption}
                              defaultChecked={true}
                            />
                            <div className="card">
                              <div className="checked">
                                <FaCheck />
                              </div>
                              <div className="amount">
                                <span>
                                  Pay{" "}
                                 1212
                                  Now!
                                </span>
                              </div>

                              <div className="desc">
                                <span>
                                  Pay your Monthly Premium
                                  <b>
                                    {" "}
                                    2121
                                  </b>{" "}
                                  now and proceed.
                                </span>
                              </div>
                            </div>
                          </label>
                        </div>
                      </RadioContainer>
                    </div>

                    <div className="col-md-6 col-xs-12 ">
                      <RadioContainer channel={journeyState.channel}>
                        <div>
                          <label className="width">
                            <input
                              type="radio"
                              name="pay"
                              value="later"
                              hidden
                              onChange={handlePayOption}
                            />
                            <div className="card">
                              <div className="checked">
                                <FaCheck />
                              </div>
                              <div className="amount">
                                <span>
                                  Pay{" "}
                                 12121
                                  Later!
                                </span>
                              </div>

                              <div className="desc">
                                <span>
                                  Continue with your applicaiton and pay
                                  <b>
                                   1212
                                  </b>{" "}
                                  later.
                                </span>
                              </div>
                            </div>
                          </label>
                        </div>
                      </RadioContainer>
                    </div>
                  </div>
                  </div>

               
                <div className="clearfix"></div>
                <div className="iselect-mg-bottom mt-30 pt-20 hidden-desktop-screen">
                <div className="col-md-12">
                    <div className="but-center text-right">
                    <div className="submit-btn cen"> <a aria-hidden="true" onClick={handlePrevious}> PREVIOUS </a> </div>
                    <input className="previous-btn cen text-uppercase ls2" style={{color: "white", padding: "14px 40px", border:"none"}} type="submit" value="PROCEED" onClick={handleProceed} />
                    </div>
                </div>
                </div>
                <div className="iselect-mg-bottom">
                <div className="col-md-12">
                    <div className="discloser iselect-box-design">
                    <h2>Risk Factors </h2>
                    <ul className="mb-20">
                        <li>There is no guarantee on the amount of bonuses and these will be declared at the sole discretion of the company. Hence, the bonuses in this plan may vary from time to time.</li>
                    </ul>
                    <h2>Disclosures</h2>
                    <ul>
                        <li>Non Staff policies only : Corporate Agent will receive commission basis the premium payment term (PPT) of the policy from the company for this transaction:-</li>
                        <li>&lt; &lt;15 years PPT&gt; &gt; :- &lt;&lt;35&gt;&gt;% commission on 1st year premium, &lt;&lt;7.5 %&gt;&gt; in 2nd &amp; 3rd Year and &lt;&lt;7.5%&gt;&gt; from 4th year onwards. </li>
                        <li>IRDA regulations do not permit Corporate Agent or its employees to pay such commission, whether in part or whole, as an inducement to any person to take out or renew or continue an insurance policy of any kind. </li>
                        <li>IRDA regulations do not permit Corporate Agent or its employees to pay such commission, whether in part or whole, as an inducement to any person to take out or renew or continue an insurance policy of any kind.</li>
                        <li>&lt;&lt; Staff policies only&gt;&gt;: Corporate Agent will receive commission basis the premium payment term (PPT) of the policy from the company for this transaction:- </li>
                        <li>&lt;&lt;15 years PP&gt;&gt; :- &lt;&lt;17.5&gt;&gt;% commission on 1st year premium, &lt;&lt;7.5 %&gt;&gt; in 2nd &amp; 3rd Year and &lt;&lt;7.5%&gt;&gt; from 4th year onwards.</li>
                        <li>IRDA regulations do not permit Corporate Agent or its employees to pay such commission, whether in part or whole, as an inducement to any person to take out or renew or continue an insurance policy of any kind.</li>
                        <li>IRDA regulations do not permit Corporate Agent or its employees to pay such commission, whether in part or whole, as an inducement to any person to take out or renew or continue an insurance policy of any kind.</li>
                    </ul>
                    </div>
                </div>
            </div>
            </form>
            )}
        </div>
        </div>
        {/* <!--mobile view button--> */}
        <div className="mobile-view-btn-Q1">
        <div className="iselect-mg-bottom">
            <div className="col-md-12">
            <div className="but-center text-center">
                <div className="submit-btn cen"> <a aria-hidden="true" onClick={handlePrevious}>Previous</a> </div>
                <input className="previous-btn cen" style={{color: "white", padding: "14px 30px", border:"none"}} type="submit" form="calculatePremium" value="Proceed" onClick={handleProceed}/>
            </div>
            </div>
        </div>
        </div>

    </>
  )
}
